import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { api } from "../../lib/api";

export function AdminShell() {
  const nav = useNavigate();
  const qc = useQueryClient();

  const logout = async () => {
    await api("/api/auth/logout", { method: "POST" });
    await qc.invalidateQueries({ queryKey: ["me"] });
    nav("/");
  };

  return (
    <div className="min-h-dvh bg-slate-50 flex flex-col">
      <header className="bg-slate-900 text-white">
        <div className="mx-auto max-w-6xl px-4 py-3 flex items-center gap-4">
          <Link to="/admin" className="font-semibold">petloc admin</Link>
          <nav className="flex items-center gap-1 flex-1">
            <Tab to="/admin/orders">Bestellungen</Tab>
            <Tab to="/admin/pets">Haustiere</Tab>
            <Tab to="/admin/users">Nutzer</Tab>
          </nav>
          <Link to="/app" className="text-sm underline">zurück zu meinen Haustieren</Link>
          <button onClick={logout} className="text-sm underline">Abmelden</button>
        </div>
      </header>
      <main className="mx-auto w-full max-w-6xl px-4 py-6 flex-1"><Outlet /></main>
    </div>
  );
}

function Tab({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `px-3 py-2 rounded text-sm ${isActive ? "bg-white text-slate-900" : "text-slate-300 hover:bg-slate-800"}`
      }
    >
      {children}
    </NavLink>
  );
}
